export const isIE = !!window
  && !!document
  && !!window.MSInputMethodContext
  && !!document.documentMode



// WEBPACK FOOTER //
// ./src/utils/ie.js